// src/store/actions/claimprocedure.action.ts
import { createAsyncThunk } from '@reduxjs/toolkit'
import claimsData from '@assets/mockdata/Claims/claimsData'
import { Procedure } from '@dataTypes/claimManagement.types'

export const fetchAllClaimProcedures = createAsyncThunk(
  'api/claimprocedure/fetch/all',
  async () => {
    const procedures: Procedure[] = claimsData.flatMap(
      (claim) => claim.procedures,
    )
    return procedures
  },
)

export const addClaimProcedure = createAsyncThunk(
  'api/claimprocedure/add',
  async (procedure: Procedure) => {
    const newProcedure: Procedure = {
      ...procedure,
      procedureCode: `PR${Math.floor(Math.random() * 1000000)
        .toString()
        .padStart(6, '0')}`,
    }
    return newProcedure
  },
)

export const updateClaimProcedure = createAsyncThunk(
  'api/claimprocedure/update',
  async (params: {
    procedureCode: string
    updatedProcedure: Partial<Procedure>
  }) => {
    const { procedureCode, updatedProcedure } = params
    return { procedureCode, updatedProcedure }
  },
)

export const deleteClaimProcedure = createAsyncThunk(
  'api/claimprocedure/delete',
  async (procedureCode: string) => {
    return procedureCode
  },
)
